import React, { useId, useMemo } from "react";
import {
  PAGE_NUMBER_FORMATS,
  formatPageNumberLabel,
} from "./pageNumberSettings";
import CoolCheckbox from "../../../../../components/shared/CoolCheckbox";
import "../../../watermark/Popup/WatermarkControls.css";
import "./PageNumberControls.css";

/**
 * Left-panel controls for PDF Page Numbers (format / start / skip).
 * Typography, color, and position live on the canvas text toolbar.
 */
const PageNumberControls = ({
  settings,
  onChange,
  disabled = false,
  samplePage = 1,
  samplePageCount = 12,
}) => {
  const skipId = useId();

  const patch = (partial) => {
    if (disabled || typeof onChange !== "function") return;
    onChange({ ...settings, ...partial });
  };

  const previewLabel = useMemo(
    () => formatPageNumberLabel(samplePage, samplePageCount, settings),
    [samplePage, samplePageCount, settings]
  );

  return (
    <div className={`wmc ppn-controls-root${disabled ? " is-disabled" : ""}`}>
      <div className="wmc-field">
        <span className="wmc-field__label">Format</span>
        <div
          className="wmc-mode-row ppn-format-row"
          role="group"
          aria-label="Number format"
        >
          {PAGE_NUMBER_FORMATS.map((fmt) => (
            <button
              key={fmt.id}
              type="button"
              className={`wmc-mode${
                settings.formatId === fmt.id ? " is-active" : ""
              }`}
              disabled={disabled}
              aria-pressed={settings.formatId === fmt.id}
              title={fmt.example}
              onClick={() => patch({ formatId: fmt.id })}
            >
              {fmt.label}
            </button>
          ))}
        </div>
        <p className="ppn-format-preview">Preview: {previewLabel}</p>
      </div>

      <div className="wmc-field">
        <label className="wmc-field__label" htmlFor="ppn-start">
          Start at
        </label>
        <input
          id="ppn-start"
          type="number"
          className="wmc-input"
          min={0}
          max={9999}
          step={1}
          value={settings.startAt}
          disabled={disabled}
          onChange={(e) => {
            const n = Math.floor(Number(e.target.value));
            patch({ startAt: Number.isFinite(n) ? Math.max(0, n) : 1 });
          }}
        />
      </div>

      <CoolCheckbox
        id={skipId}
        className="wmc-embed ppn-skip"
        checked={Boolean(settings.skipFirstPage)}
        disabled={disabled}
        label="Skip first page"
        onChange={(e) => patch({ skipFirstPage: e.target.checked })}
      />
    </div>
  );
};

export default PageNumberControls;
